export class ListGrantedOrganizationGroupAccessResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "groups",
            "baseName": "groups",
            "type": "Array<OrganizationGroupAccess>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGrantedOrganizationGroupAccessResponse.attributeTypeMap;
    }
    constructor() {
    }
}
